import React, { useEffect, useRef } from 'react';
import { InputRef, Select } from 'antd';

export const OptionsFilter = (props: any) => {
  const inputRef = useRef<InputRef>(null);
  useEffect(() => {
    inputRef.current?.focus();
  }, [inputRef]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ margin: '16px 14px' }}>
      <Select
        className={`${props.value ? 'filter-circle-clear' : ''}`}
        style={{ width: '100%' }}
        options={props.options || []}
        allowClear
        onChange={props.onChange}
        value={props.value}
      />
    </div>
  );
};
